export class LoanFeeRecommendationsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getRecommendations({ loanId }) {
    return this.#http.get(`/api/loans/${encodeURIComponent(loanId)}/fee-recommendations`);
  }

  async acceptItem({ loanId, itemId }) {
    return this.#http.post(
      `/api/loans/${encodeURIComponent(loanId)}/fee-recommendations/items/${encodeURIComponent(itemId)}/accept`,
    );
  }

  async rejectItem({ loanId, itemId, reviewNotes }) {
    return this.#http.post(
      `/api/loans/${encodeURIComponent(loanId)}/fee-recommendations/items/${encodeURIComponent(itemId)}/reject`,
      {
        reviewNotes,
      },
    );
  }

  async acceptAll({ loanId, sessionId, itemIds }) {
    return this.#http.post(
      `/api/loans/${encodeURIComponent(loanId)}/fee-recommendations/sessions/${encodeURIComponent(sessionId)}/accept-all`,
      { itemIds },
    );
  }

  async rejectAll({ loanId, sessionId, reviewNotes }) {
    return this.#http.post(
      `/api/loans/${encodeURIComponent(loanId)}/fee-recommendations/sessions/${encodeURIComponent(sessionId)}/reject-all`,
      { reviewNotes },
    );
  }
}
